export const FETCH_FAMILY_BY_FLAT = "FETCH_FAMILY_BY_FLAT"
export const FETCH_FAMILY_BY_ONE = "FETCH_FAMILY_BY_ONE"
export const FETCH_FAMILY_SELECT = "FETCH_FAMILY_SELECT"
export const GET_RELATION_TYPE_SELECT = "GET_RELATION_TYPE_SELECT"
export const GET_OWNER_CHANGES = "GET_OWNER_CHANGES"
export const CREATE_FAMILY_MEMBER = "CREATE_FAMILY_MEMBER"
export const UPDATE_FAMILY_MEMBER = "UPDATE_FAMILY_MEMBER"
export const DELETE_FAMILY_MEMBER = "DELETE_FAMILY_MEMBER"